var ReCaptchaActionOptions;
(function (ReCaptchaActionOptions) {
  ReCaptchaActionOptions["ResendEmailRequest"] = "resend_email_request";
  ReCaptchaActionOptions["UserExistence"] = "user_existence";
  ReCaptchaActionOptions["UsernameExistence"] = "username_existence";
})(ReCaptchaActionOptions || (ReCaptchaActionOptions = {}));
var ReCaptchaActionOptions$1 = ReCaptchaActionOptions;

export { ReCaptchaActionOptions, ReCaptchaActionOptions$1 as default };
//# sourceMappingURL=index.js.map
